import FrequentlyUsedField from "@/enum/FrequentlyUsedField";

const FrequentlyUsedFieldNameMap = {
    [FrequentlyUsedField.AFFILIATE_MARKETER]: "订单来源",
    [FrequentlyUsedField.BUYER_REMARKS]: "买家留言",
    [FrequentlyUsedField.BUYER_USERNAME]: "买家昵称",
    [FrequentlyUsedField.CONSIGNEE_AREA]: "收货人省市区",
    [FrequentlyUsedField.CONSIGNEE_NAME]: "收货人",
    [FrequentlyUsedField.CONSIGNEE_PHONE]: "手机电话",
    [FrequentlyUsedField.CONSIGNEE_STREET]: "收货人街道",
    [FrequentlyUsedField.LOGISTICS_COMPANY]: "快递公司",
    [FrequentlyUsedField.LOGISTICS_INFO_STATUS]: "物流信息",
    [FrequentlyUsedField.LOGISTICS_STAGNANT_HOURS]: "物流停滞",
    [FrequentlyUsedField.REMAINING_SHIPPING_HOURS]: "剩余发货时间",
    [FrequentlyUsedField.ORDER_ITEM_EXTERNAL_ID]: "商品编码",
    [FrequentlyUsedField.ORDER_ITEM_TITLE]: "商品名称",
    [FrequentlyUsedField.ORDER_MARK]: "订单标记",
    [FrequentlyUsedField.ORDER_ORIGINAL_ID]: "订单编号",
    [FrequentlyUsedField.ORDER_TIME_RANGE]: "下单/付款/打印/发货时间",
    [FrequentlyUsedField.ORDER_TAG]: "包含标签",
    [FrequentlyUsedField.EXCLUDED_ORDER_TAG]: "不含标签",
    [FrequentlyUsedField.PAYMENT_AMOUNT_RANGE]: "实付金额范围",
    [FrequentlyUsedField.PRINT_STATUS]: "打印状态",
    [FrequentlyUsedField.PRODUCT_ORIGINAL_ID]: "商品ID",
    [FrequentlyUsedField.SKU_ORIGINAL_ID]: "SKUID",
    [FrequentlyUsedField.QUANTITY_RANGE]: "商品数量范围",
    [FrequentlyUsedField.QUICK_CRITERION]: "快捷选单",
    [FrequentlyUsedField.RETAILER]: "代理商",
    [FrequentlyUsedField.SELLER_FLAG]: "旗帜颜色",
    [FrequentlyUsedField.SELLER_REMARKS]: "卖家备注",
    [FrequentlyUsedField.SHIPPING_ADDRESS]: "快递分区",
    [FrequentlyUsedField.SHIPPER]: "发货人",
    [FrequentlyUsedField.SKU_PROPERTIES]: "商品属性",
    [FrequentlyUsedField.STOCK_NO]: "商品货位",
    [FrequentlyUsedField.SUPPLIER]: "供应商",
    [FrequentlyUsedField.UNDELIVERABLE_AREA]: "不可达",
    [FrequentlyUsedField.WAYBILL_NO]: "运单号",
    [FrequentlyUsedField.WEIGHT_RANGE]: "重量范围",
    [FrequentlyUsedField.PRINT_BATCH_NO]: "批次号",
    [FrequentlyUsedField.ITEM_STATUSES]: "商品状态",
};

export default FrequentlyUsedFieldNameMap;
